import React, { useState } from "react";
import { Button, Form } from "reactstrap";
import Logo from "../../components/Logo";
import { Link } from "react-router-dom";
import { useForgotPasswordQuery } from "../../hooks/authQueries";
import ButtonLoader from "../../components/common/buttonLoader";

const EmailVerification = () => {
  const [userMail, setUserMail] = useState("");
  const [error, setError] = useState();
  const handleOnChangeFuntion = (e) => {
    setUserMail(e.target.value);
  };
  // Asks for a reset link. The account's password is not touched until the
  // owner opens the emailed link and chooses a new one.
  const {
    data: sent,
    mutate,
    isPending,
    error: queryError,
  } = useForgotPasswordQuery();

  const handleSubmitFunction = async (e) => {
    e.preventDefault();
    if (!userMail || isPending) {
      setError(true);
    } else {
      mutate(userMail.trim());
    }
  };

  return (
    <div className="row signup_mobile_container full_view_container">
      <div className="col-xl-5 col-lg-5 col-md-5 hide_img">
        <div className="reset_banner_img" />
      </div>
      <div className="col-xl-7 col-lg-7 col-md-7 col-sm-12">
        <div className="padding_left_signup ">
          <div style={{ marginTop: 70 }}>
            <Logo />
          </div>
          <h4 className="heading" style={{ marginTop: 50 }}>
            Forgot your password?
          </h4>
          {sent ? (
            <>
              <p className="status-message" role="status">
                {sent.message} The link expires in 30 minutes. Check your spam folder if it does not arrive.
              </p>
              <Link to="/">Back to sign in</Link>
            </>
          ) : (
          <>
          <p className="subheading" style={{ marginTop: -5 }}>
            Enter your email and we will send you a link to choose a new password.
          </p>
          {queryError && (
            <p style={{ color: "#b3261e", marginTop: 8 }} role="alert">
              {queryError?.response?.data?.message || "Could not send the email. Please try again."}
            </p>
          )}
          <Form onSubmit={handleSubmitFunction}>
            <p className="input_lbl" style={{ marginTop: 10 }}>
              Email
            </p>
            <div
              className={
                error && userMail?.length < 1
                  ? "reset_input_div border border-danger"
                  : "reset_input_div"
              }
              style={{ marginTop: -10 }}
            >
              <input
                className="reset_input_field"
                type="email"
                placeholder="Enter Your Email"
                name="email"
                autoComplete="email"
                onChange={handleOnChangeFuntion}
              ></input>
            </div>
            <Button
              type="submit"
              className="submit_btn"
              style={{ marginTop: 40 }}
            >
              {isPending ? <ButtonLoader /> : "Send reset link"}
            </Button>
          </Form>
          <p style={{ marginTop: 20 }}><Link to="/">Back to sign in</Link></p>
          </>
          )}
          <br />
        </div>
      </div>
    </div>
  );
};

export default EmailVerification;
